<p-dropdown
  *ngIf="_frmControl"
  [options]="offices"
  optionLabel="name"
  optionValue="id"
  styleClass="w-full"
  [formControl]="_frmControl"
  [filter]="true"
  filterBy="name"
  [readonly]="readOnly"
  (onFilter)="filterOffices$.next($event.filter)"
  [emptyFilterMessage]="'Inserire il nome della sede o del magazzino'"
  [emptyMessage]="'Nessun risultato trovato'"
  [dropdownIcon]="readOnly ? 'pi' : undefined"
  [ngClass]="{ 'read-only': readOnly }"></p-dropdown>
